import formatePrice from '../../formatePrice'

// template for infoBox with name only (departure marker)
const markerLabel = marker => `
  <div id="marker-${marker.id}" class="marker only-name">
    <span class="marker-name">${marker.name}</span>
  </div>
`

export default markerLabel



// WEBPACK FOOTER //
// ./app/utils/infoBox/templates/markerLabel.js